export default __webpack_public_path__ + "static/media/allpos_white.7584a223.svg";